import request from '@/api/request'
export default{
    getStudents:params=>request.get('/students/getStudents',{params}),
    getStudentsById:_id=>request.get('/students/getStudentsById',{params:{_id}}),
    updateStudents:data=>request.put('/students/updateStudents',data)
}   